import React, { useCallback, useEffect, useState } from 'react';
import Table from '../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetSubscriptionApi } from '../redux/actions/teams/members/GetSubscriptionActions';
import { PulseLoader } from 'react-spinners';

const Subscriptions = () => {
   const columns = ['Plan Name', 'Amount(£)','Created On','Status', 'Action'];
    const { response: listResponse, loading: listLoading, error: listError } = useSelector((state) => state.subscriptionList);
    
    const dispatch = useDispatch();
    const [dataList, setDataList] = useState([]);



    const fetchQuizList = useCallback(() => {
        dispatch(GetSubscriptionApi());
    }, [dispatch]);


    const handleRetry = () => {
  window.location.reload(); // or trigger your data-fetching again
};

    useEffect(() => {
        fetchQuizList();
    }, [fetchQuizList]);

    useEffect(() => {
        if (listResponse?.status) {
            setDataList(listResponse?.data || []);
        }
    }, [listResponse]);

    return (
        <div className="content-wrapper">
            <section className="main-section spacer-y">
                <div className="container">
                    <div className="row gy-4">
                         <div className="common_sub_heading_wrapper">
                                <h2>Subscription</h2>
                            </div>

                            <div className="tab-content common_tab_content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="pills-1"
                                    role="tabpanel"
                                    aria-labelledby="pills-1-tab"
                                    tabIndex="0"
                                >
                                    {listLoading ? (
                                        <div style={{ height: '40vh' }} className="d-flex align-items-center justify-content-center">
                                            <PulseLoader size={25} color="#49a496" />
                                        </div>
                                    ) : listError ? (
                                    
                                        <div className="center-container">
                                            <div className="error-box">
                                            <i className="bi bi-exclamation-triangle-fill"></i>
                                            <p>Something went wrong</p>
                                            <button className="retry-btn" onClick={handleRetry}>
                                                Try Again
                                            </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <Table
                                                tableData={dataList}
                                                setDataList={setDataList}
                                                columns={columns}
                                                title={'subscription'}

                                            />
                                        </>
                                    )}
                                </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Subscriptions